import { memo } from 'react';

import {
  Guidingtip,
  GUIDINGTIP_ALIGNS,
  GUIDINGTIP_POSITIONS,
  GUIDINGTIP_THEMES,
  useOnboarding,
} from '@wg/wows-react-uikit';

import { ONBOARDING_GUIDES } from '~/const/onboarding';
import { t } from '~/helpers/localization';

import styles from './ClanHubTile.module.scss';
import ClanHubTileContent from './ClanHubTileContent';

import type { CLAN_HUB_TILE_SIZE } from './ClanHubTile';
import type { HubTileModel } from '../clanHub.tiles.build';
import type { ROLE_NAMES } from '~/roles';

interface ClanHubTileProps {
  tile: HubTileModel;
  size: CLAN_HUB_TILE_SIZE;
  currentRoleName?: ROLE_NAMES | null;
  onClick?: () => void;
}

const ClanHubTileWithGuidingtip = ({ tile, size, currentRoleName = null, onClick }: ClanHubTileProps) => {
  const { onboardingStep, guidingtip } = tile.onboarding!(currentRoleName);

  const { isCurrentStepCompleted, completeSteps } = useOnboarding({
    stepName: onboardingStep,
  });

  const handleClick = () => {
    onClick?.();

    if (!isCurrentStepCompleted) {
      completeSteps([onboardingStep]);
    }
  };

  if (isCurrentStepCompleted) {
    return <ClanHubTileContent tile={tile} size={size} onClick={onClick} />;
  }

  return (
    <Guidingtip
      className={styles.tileGuidingtip}
      name={guidingtip.name}
      header={guidingtip.header}
      content={guidingtip.content}
      position={GUIDINGTIP_POSITIONS.BOTTOM}
      align={GUIDINGTIP_ALIGNS.CENTER}
      theme={GUIDINGTIP_THEMES.CLIENT}
      delay={1000}
      withBeacon
      completeOnClick
      isActionBtnVisible
      actionBtnText={guidingtip.name === ONBOARDING_GUIDES.CLANSTARS_REFINED ? t('Закрыть') : undefined}
    >
      <ClanHubTileContent tile={tile} size={size} currentRoleName={currentRoleName} onClick={handleClick} />
    </Guidingtip>
  );
};

export default memo(ClanHubTileWithGuidingtip);
